import { Component, Input } from '@angular/core'
import { LayoutService } from '../../services/layout/layout.service'
import { ActivatedRoute, Router } from '@angular/router'
import { Filter, QueryGet } from '../../shared/query-types'
import { catchError, map, Observable, switchMap, tap } from 'rxjs'
import { Education } from '../../models/education.interface'
import { PAGINATION } from '../../shared/constants'
import { EducationService } from '../../services/education/education.service'
import { AsyncPipe, CommonModule } from '@angular/common'
import { MatIcon } from '@angular/material/icon'
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
} from '@angular/material/table'
import { NgxPaginationModule } from 'ngx-pagination'
import { SearchComponent } from '../../components/search/search.component'
import { Pagination } from '../../models/pagination.interface'
import { ToastrService } from 'ngx-toastr'
import { MatDialog } from '@angular/material/dialog'
import { EducationFormComponent } from '../education-form/education-form.component'
import { LoadingService } from '../../services/loadingService/loading.service'
import { OnlysuperuserDirective } from '../../directives/onlysuperuser.directive'
import { Title } from '@angular/platform-browser'

@Component({
    selector: 'app-education-list',
    standalone: true,
    imports: [
        CommonModule,
        MatIcon,
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        NgxPaginationModule,
        AsyncPipe,
        SearchComponent,
        OnlysuperuserDirective,
    ],
    templateUrl: './education-list.component.html',
    styleUrl: './education-list.component.css',
})
export class EducationListComponent {
    public page: number | undefined
    @Input() filtro: string = ''
    @Input() orden: string = ''
    limit = 10
    total = 0
    educationList: Education[] = []
    selectedEducation: Education | null = null
    asyncEducation!: Observable<Pagination<Education[]>>
    showColumns: string[] = [
        'acciones',
        'personalData',
        'level',
        'culturalKnowledge',
        'nasaYuwe',
        'isIlliterate',
    ]

    constructor(
        private layoutService: LayoutService,
        private activatedRouter: ActivatedRoute,
        private educationService: EducationService,
        private router: Router,
        private toastr: ToastrService,
        private dialog: MatDialog,
        private title: Title,
        private loadingService: LoadingService
    ) {this.title.setTitle('Educación')}

    fetchEducation(page: number, filter: Filter | null = null, search = '') {
        const offset = page > 1 ? page * this.limit - this.limit : 0
        const params: QueryGet = {
            order: '-id',
            limit: this.limit,
            offset,
            search,
            filters: [],
        }
        if (filter) {
            params.filters.push(filter)
        }
        this.page = page
        this.loadingService.show(true)
        this.asyncEducation = this.educationService.allEducations(params).pipe(
            tap((response) => {
                this.educationList = response.results
                this.educationService.setEducations(response.results)
                this.total = response.count
            }),
            map((res) => {
                this.loadingService.show(false)
                return res
            }),
            catchError((error) => {
                this.loadingService.show(false)
                this.router.navigate(['home/'])
                return []
            })
        )
    }

    ngOnInit(): void {
        this.layoutService.paginationLimit$
            .pipe(
                switchMap((limit) => {
                    this.limit = limit
                    return this.activatedRouter.queryParamMap
                }),
                switchMap((params) => {
                    const pageNum = params.get('page') || '1'
                    const search = params.get('search') || ''
                    this.page = parseInt(pageNum)
                    this.fetchEducation(PAGINATION.first_page, null, search)
                    return this.layoutService.paginationLimit$
                })
            )
            .subscribe()
    }

    eliminate(education: Education): void {
        const confirmed = window.confirm(
            `¿Estás seguro de eliminar el registro: ${education.level}`
        )
        if (!confirmed) return
        this.educationService.deleteEducation(education.id).subscribe({
            next: () => {
                const successMsg = `Eliminado CORRECTAMENTE!`
                this.toastr.success(successMsg, 'Exitoso!', {
                    progressBar: true,
                    timeOut: 5000,
                })
                this.fetchEducation(PAGINATION.first_page)
            },
            error: (err) => {
                this.toastr.error('No se pudo eliminar', 'Error')
            },
        })
    }

    updateEducation(education: Education) {
        this.educationService.setEducation(education)
        const dialogRef = this.dialog.open(EducationFormComponent, {
            data: { selectedEducation: this.selectedEducation },
            width: '90vw',
            maxWidth: '80vw',
            maxHeight: '80vh',
        })
        dialogRef.afterClosed().subscribe(() => {
            this.fetchEducation(PAGINATION.first_page)
        })
    }
    create(): void {}
}
